import { Document, Font, Image, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import QRCode from "qrcode"; // Use the `qrcode` package to generate QR code data URL
import { useEffect, useState } from "react";

// Define the styles for the PDF
const styles = StyleSheet.create({
    page: {
        position: 'relative',
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between', // Ensure spacing between content sections
    },
    backgroundImage: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover', // Ensure it covers the entire page
        zIndex: -1, // Make sure it's behind the content
    },
    section: {
        flexGrow: 1,
        padding: 10, // Tighten padding
        alignItems: 'center',
        justifyContent: 'center',
    },
    title: {
        marginTop: '-17px',
        fontSize: 18,
        marginBottom: 5,
        textAlign: 'center',
        color: '#FFFFFF'
    },
    qrCodeContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        marginVertical: 5, // Reduce vertical margin
    },
    qrCode: {
        width: 120,
        height: 120, // Reduce QR code size further
    },
    logo: {
        width: 60,
        height: 60,
        borderRadius: 30,
        marginTop: 8,
    },
    imgs: {
        height: 23,
        width: 150,
        marginTop: 10,
    },
    footer: {
        marginTop: 10,
        marginLeft: '-45px',
        textAlign: 'center',
        fontSize: 7,
        color: '#FFFFFF',
        fontFamily: 'CustomFont',
        fontWeight: 'normal',
    },
    footerLogo: {
        height: 20,
        width: 100,
    },
});

// Main QR code component
const Qrcode = ({ data }: any) => {
    Font.register({
        family: 'CustomFont',
        src: 'Roboto/Roboto-Bold.ttf', // Replace with your font path
        fonts: [
            { src: 'Roboto/Roboto-Light.ttf', fontWeight: 'normal' },
            { src: 'Roboto/Roboto-Bold.ttf', fontWeight: 'bold' },
            // { src: 'path/to/font-extrabold.ttf', fontWeight: 'extrabold' }
        ],
    });

    const qrCodeContent = JSON.stringify({
        id: data?.id,
        name: data?.name,
    });
    const qrCodeDataUrl = QRCode.toDataURL(qrCodeContent, {
        width: 120, // Reduced size for fitting the page
        margin: 1,
    });

    return (
        <Document>
            <Page size={{ width: 240, height: 420 }} style={styles.page}>
                {/* Background Image */}
                <Image src="bg4.png" style={styles.backgroundImage} />

                {/* Content Section */}
                <View style={styles.section}>
                    <Text style={styles.title}>Scan Me</Text>
                    <View style={styles.qrCodeContainer}>
                        <Image src={qrCodeDataUrl} style={styles.qrCode} />
                    </View>
                    <Image src={data?.logo} style={styles.logo} />
                    <Text style={{ fontFamily: 'CustomFont', fontWeight: 'bold', fontSize: 14, marginTop: 5, color: '#FFFFFF', textAlign: 'center' }}>{data?.name}</Text>
                    <Text style={{ fontFamily: 'CustomFont', fontWeight: 'normal', fontSize: 10, marginTop: 5, textAlign: 'center', color: '#FFFFFF' }}>Scan the QR code to view details and book Turf.</Text>
                </View>

                {/* Footer Section */}
                <View style={{ alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
                    <Image src="g-play-apple-play.png" style={styles.imgs} />
                </View>
                <Text style={styles.footer}>Powered by</Text>
                <View style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 3, marginBottom: 10 }}>
                    <Image src="NameLogo.png" style={styles.footerLogo} />
                </View>
            </Page>
        </Document>
    );
}


export default Qrcode;
{/* <Document>
    <Page size="A4" style={styles.page}>
        <View style={styles.section}>
            <div
                id="qrCodeDesign"
                ref={ref}
                style={{
                    background: 'linear-gradient(118deg, rgba(0,0,0,1) 0%, rgba(147,7,0,1) 100%)'
                }}
                className="p-4 text-center border rounded-md shadow-md w-full max-w-xs h-[80vh] relative"
            >
                
                <h1 className="text-2xl font-bold text-white mb-4">Scan Me</h1>

                <div className="mb-2 flex items-center justify-center">
                    <QRCode
                        value={data.id + ' ' + data.name}
                        bgColor="#FFFFFF"
                        fgColor="#000000"
                        size={200}
                        style={{ border: '5px solid white', padding: '5px', borderRadius: 10 }}
                    />
                </div>

                <div className="flex items-center justify-center mt-7">
                    <img
                        src={data.logo}
                        alt=""
                        onError={(e) => {
                            e.currentTarget.src = "/wood-blog-placeholder.jpg"; // Fallback image
                        }}
                        className="rounded-full object-contain border-2 w-20 h-20"
                    />
                </div>
                <h1 className="text-3xl text-white font-bold mt-0">{data.name}</h1>
                <p className="text-xl text-white mt-5">Scan the QR code to view details and book Turf.</p>
                <div className="flex items-center justify-center" style={{ marginTop: 20 }}>
                    <img
                        src="g-play-apple-play.png"
                        alt=""
                        onError={(e) => {
                            e.currentTarget.src = "/wood-blog-placeholder.jpg"; // Fallback image
                        }}
                        className="object-contain w-60 h-60"
                    />
                </div>
                <div className="absolute bottom-4 left-0 right-0 flex flex-col items-center justify-center">
                    <span style={{ fontSize: 11, marginLeft: "-50px" }} className="text-white mb-1">Powered by</span>
                    <div className="flex items-center justify-center space-x-2">
                        <img
                            src="logo.png"
                            alt="EasyTurf Logo"
                            className="w-10 h-10 rounded-full border-2 border-white"
                        />
                        <span className="font-bold text-white">EasyTurf</span>
                    </div>
                </div>
            </div>
        </View>
    </Page>
</Document> */}